import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./cause-dm-page.component').then((c) => c.CauseDmPageComponent),
    data: {
      page_name: 'cause_dm_page',
      lastOrderSkip: false
    }
  }
];